import { memo } from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Control, FieldErrors } from 'react-hook-form';
import FormNumberInput from './FormNumberInput';
import { paymentSettingsSchema, PaymentSettingsFormData } from '../../schema';
import type { input, output } from 'zod';
import { StyleObj } from '../../@types';

type FieldConfig = {
  label: string;
  name: keyof PaymentSettingsFormData;
  allowDecimals: boolean;
};

const styles: StyleObj = {
  numberInput: {
    fontSize: { xs: 12, md: 14 },
    textAlign: 'center',
  },
};

type PaymentSettingRowProps = {
  field: FieldConfig;
  control: Control<input<typeof paymentSettingsSchema>, unknown, output<typeof paymentSettingsSchema>>;
  errors: FieldErrors<input<typeof paymentSettingsSchema>>;
  disabled: boolean;
};

const PaymentSettingRow = memo(({ field, control, errors, disabled }: PaymentSettingRowProps) => {
  return (
    <TableRow>
      <TableCell align='center' sx={{ backgroundColor: 'background.lighter' }}>
        {field.label}
      </TableCell>
      <TableCell align='center'>
        <FormNumberInput
          control={control}
          name={field.name}
          variant='standard'
          helperText={errors[field.name]?.message}
          disabled={disabled}
          allowDecimals={field.allowDecimals}
          valueAsString
          slotProps={{
            input: {
              placeholder: 'Not set',
              disableUnderline: true,
            },

            htmlInput: {
              sx: styles.numberInput,
            },
          }}
        />
      </TableCell>
    </TableRow>
  );
});

export default PaymentSettingRow;
